export const SentrySymbol = Symbol.for('SentryAdapter');

export interface ISentryAdapter {
    captureMessage(message: string, options?: { scope: (scope: any) => any });
}
